//@flow
import _ from 'lodash';

class StringUtils {
    static isEmpty(value: any): boolean {
        if (_.isNumber(value)) {
            return !_.isFinite(value); // if finite, return false. Covers NaN
        }

        return _.isEmpty(value);
    }

    static trimFirstAndLastCharacter(string: string) {
        return string.substring(1, string.length - 1);
    }

    static isEmail(email: string): boolean {
        var re = /\S+@\S+\.\S+/;
        return email && re.test(email);
    }
    static stringGroupingHelper(
        inString: string = '',
        separator: string = '\n\n'
    ): string {
        return inString !== '' ? `${inString}${separator}` : inString;
    }
    static alphabeticalComparator = (first: string, second: string): number => {
        var FIRST = first.toLowerCase();
        var SECOND = second.toLowerCase();
        if (FIRST < SECOND) {
            return -1;
        } else if (FIRST > SECOND) {
            return 1;
        } else {
            return 0;
        }
    };

    static pluralize(
        string?: string,
        length?: number | string,
        emptyString?: ?string,
        showNumber: boolean = true,
        placeHolder: string = '-'
    ): string {
        const stringLength = Number(length);
        if (StringUtils.isEmpty(stringLength) || StringUtils.isEmpty(string)) {
            return placeHolder;
        }
        if (string) {
            if (stringLength > 1 || (stringLength > 0 && stringLength < 1)) {
                return showNumber ? `${stringLength} ${string}s` : `${string}s`;
            } else if (stringLength === 1) {
                return showNumber ? `${stringLength} ${string}` : string;
            } else if (stringLength === 0) {
                return emptyString
                    ? emptyString
                    : showNumber
                    ? `No ${string}s`
                    : `${string}s`;
            }
        }
        return placeHolder;
    }

    static toTitleCase(value: string): string {
        if (value) {
            const source = value.toLowerCase();
            return source.charAt(0).toUpperCase() + source.substr(1);
        }
        return value;
    }

    static sentenceToTitleCase(value: string): string {
        if (value) {
            const words = value.toLowerCase().split(' ');
            const titleCaseWords = words.map(word => {
                return word.charAt(0).toUpperCase() + word.substr(1);
            });
            return titleCaseWords.join(' ');
        }
        return value;
    }

    static extractMatchingTagsWithTextFromHtmlStr(
        tag: string,
        htmlStr: string
    ): ?Array<string> {
        const reg = `<${tag}>(.*?)</${tag}>`;
        return htmlStr.match(new RegExp(reg, 'g'));
    }

    static removeTagFromText(tag: string, text: string): string {
        const reg = `</?${tag}>`;
        return text.replace(new RegExp(reg, 'g'), '');
    }

    static toSentenceCaseFromMixedCase(str: string): string {
        const delim = '. ';
        const arr = str.split(delim); // split multiple sentences
        return arr
            .map(s => {
                const formatted =
                    s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();

                return formatted;
            })
            .join(delim);
    }

    static isAlphaNumeric(str): boolean {
        const regex = /^[a-zA-Z0-9]*$/;
        return regex.test(str);
    }
}

export default StringUtils;
